import React from "react";
import { Helmet } from "react-helmet";
import btnIcon from "../../assets/images/arrow-left-orange.svg";

export default function Breadcrumb({ items }) {
    const itemClass = (items, index, item) => {
        let itemClass;
        let clsLabel;
        if (index === 0) {
            itemClass = "item home";
        } else if (index !== 0 && index < items.length - 1) {
            clsLabel = item.label?.charAt(0).toLowerCase() + item.label?.toLowerCase().slice(1).replace(/\s/g, '-');
            itemClass = `item ${clsLabel}`;
        } else if (index === items.length - 1) {
            if (item.type === 'living') {
                itemClass = "item living";
            } else {
                itemClass = "item facility";
            }
        } else {
            itemClass = "item";
        }
        return itemClass;
    };

    const breadcrumbList = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items.map((item, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "name": item.label,
            "item": item.path ? `${window.location.origin}${item.path}` : undefined
        })).filter(item => item.item)
    };

	return (
        <>
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(breadcrumbList)}
                </script>
            </Helmet>
            <section className="breadcrumbs">
                <div className="container">
                    <ul className="items">
                        {items.map((item, index) => (
                            <li className={itemClass(items, index, item)} key={index}>
                                {index < items.length - 1 ? (
                                    <>
                                        <a href={item.path} title={item.label}>
                                            {item.label}
                                        </a>
                                        <img src={btnIcon} className="img-fluid arrow-icon" alt="btnIcon" />
                                    </>
                                ) : (
                                    <strong>{item.label}</strong>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
        </>
	);
}
